export class DataDescriptor {
  constructor(
    public nameField: string,
    public valueField: string,
    public source: any[] = [],
    public filtered: any[] = []
  ) { }

  public static namevalue(): DataDescriptor {
    return new DataDescriptor('name', 'value');
  }
}